import React from 'react';
import queryString from 'query-string';
import ArticlesComponent from './Articles';
import articles from '../../../../../model/article';
import withRouter from '/src/components/misc/withRouter';

class ArticlesContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: null,
      working: false,
      showArchived: false,
      limit: 20,
      offset: 0,
      total: null,
      filter: null,
      sort: undefined
    };

    this.handleSetOffset = this.handleSetOffset.bind(this);
    this.handleToggleShowArchived = this.handleToggleShowArchived.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  componentDidMount() {
    document.title = 'Admin - MF Artikler';
    let offset = this.state.offset;
    const limit = this.state.limit;
    let sort = this.state.sort;
    let showArchived = this.state.showArchived;

    const query = queryString.parse(this.props.location.search);
    if (query) {
      if (query.page && query.page > 0) {
        offset = (query.page - 1) * limit;
      }
      if (query.showArchived) {
        showArchived = query.showArchived === 'true';
      }
      if (query.sort) {
        sort = query.sort;
      }
    }

    this.setState({
      offset: offset,
      limit: limit,
      showArchived: showArchived,
      sort: sort
    }, () => {
      this.fetchArticles(this.state.offset, this.state.limit, this.state.showArchived, this.state.sort);
    });
  }

  fetchArticles(offset, limit, showArchived, sort) {
    const params = {
      motorforum: true
    };

    params.includeArchived = showArchived;

    articles.allByParams(0, offset, limit, params, sort).then(([articles, total]) => {
      this.setState({
        articles: articles,
        working: false,
        total: total
      });
    });
  }

  handleSort(sortString) {
    this.setState({
      working: true,
      sort: sortString,
      offset: 0
    }, () => {
      this.props.history.replace({
        pathname: '/motorforum/articles',
        search: queryString.stringify({
          page: 1,
          showArchived: this.state.showArchived,
          sort: sortString
        })
      });

      this.fetchArticles(this.state.offset, this.state.limit, this.state.showArchived, this.state.sort);
    });
  }

  handleSetOffset(offset) {
    this.setState({
      working: true,
      offset: offset
    }, () => {
      this.props.history.replace({
        pathname: '/motorforum/articles',
        search: queryString.stringify({
          page: Math.floor(offset / this.state.limit) + 1,
          showArchived: this.state.showArchived
        })
      });

      this.fetchArticles(this.state.offset, this.state.limit, this.state.showArchived, this.state.sort);
    });
  }

  handleToggleShowArchived() {
    this.setState((prevState) => {
      return {
        showArchived: !prevState.showArchived,
        working: true,
        offset: 0
      };
    }, () => {
      this.props.history.replace({
        pathname: '/motorforum/articles',
        search: queryString.stringify({
          page: 1,
          showArchived: this.state.showArchived
        })
      });
      this.fetchArticles(this.state.offset, this.state.limit, this.state.showArchived, this.state.sort);
    });
  }

  render() {
    return (
      <ArticlesComponent
        articles={this.state.articles}
        working={this.state.working}
        handleToggleShowArchived={this.handleToggleShowArchived}
        showArchived={this.state.showArchived}
        total={this.state.total}
        limit={this.state.limit}
        offset={this.state.offset}
        handleSetOffset={this.handleSetOffset}
        handleSort={this.handleSort}
        sort={this.state.sort}
      />
    );
  }
}

ArticlesContainer.defaultProps = {
};

export default withRouter(ArticlesContainer);
